<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg"
            :doctorId="doctorId"></DocMsg>
    <div class="page_title">医生义诊设置查询</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <span>医生名称</span>
          <el-input v-model="doctor_name"
                    style="width: 130px; margin: 0 10px"
                    clearable
                    @input="search"></el-input>
          <span>医生手机</span>
          <el-input v-model="phone"
                    style="width: 130px; margin: 0 10px"
                    clearable
                    @input="search"></el-input>
          <span>
            <span>是否开启义诊</span>
            <el-radio-group v-model="is_free"
                            @change="search"
                            style="margin: 0 10px 0 15px">
              <el-radio :label="''">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </span>
          <span>
            <span>是否测试医生</span>
            <el-radio-group v-model="is_test"
                            @change="search"
                            style="margin: 0 10px 0 15px">
              <el-radio :label="''">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </span>
          <el-button type="info"
                     style="background-color: #eceff2; color: #747981"
                     @click="search"
                     size="medium">查询</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%; min-width: 1000px"
                    :header-cell-style="{ background: '#F5F5F5' }"
                    @sort-change="changeOrder">
            <el-table-column label="医生姓名">
              <template slot-scope="scope">
                <span v-if="scope.row.doctor_id"
                      @click="showDocMsg(scope.row.doctor_id)"
                      style="cursor:pointer">{{scope.row.doctor_name}}</span>
                <span v-else>{{scope.row.doctor_name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="phone"
                             label="手机号"></el-table-column>
            <el-table-column label="是否开启义诊">
              <template slot-scope="scope">
                <span v-if="scope.row.is_free == 1">是</span>
                <span v-else>否</span>
              </template>
            </el-table-column>
            <el-table-column prop="start_time"
                             label="下期义诊开启时间"></el-table-column>

            <el-table-column label="每期活动名额"
                             prop="number">
            </el-table-column>
            <el-table-column label="义诊周期">
              <template slot-scope="scope">
                <span v-if="scope.row.period == 0">仅本次</span>
                <span v-if="scope.row.period == 1">每一周</span>
                <span v-if="scope.row.period == 2">每两周</span>
                <span v-if="scope.row.period == 3">每三周</span>
                <span v-if="scope.row.period == 4">每四周</span>
              </template>
            </el-table-column>
            <el-table-column prop="cancel_time"
                             label="下期义诊结束时间"></el-table-column>
            <el-table-column prop="num"
                             label="累计义诊数量"
                             sortable="custom"></el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="currentPage"
                         :page-sizes="[10, 20, 50, 100]"
                         :page-size="10"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="totalNum"
                         style="margin:20px 0"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      doctor_name: '',
      phone: '',
      is_free: '',
      order: 0,
      is_test: 0,
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        phone: this.phone,
        is_free: this.is_free,
        order: this.order,
        is_test: this.is_test
      };
      this.axios
        .post('platform/Activity/getDoctorFreeConsultSetting', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.start_time = item.start_time
                ? dayjs.unix(item.start_time).format('YYYY-MM-DD HH:mm')
                : '';
              item.cancel_time = item.cancel_time
                ? dayjs.unix(item.cancel_time).format('YYYY-MM-DD HH:mm')
                : '';
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    changeOrder(value) {
      let order = value.order;
      //升序
      if (order == 'ascending') {
        this.order = 1;
      }
      //降序
      if (order == 'descending') {
        this.order = 2;
      }
      if (!order) {
        this.order = 0;
      }
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
</style>